import React from 'react';
import {LayoutDashboard, Package} from 'lucide-react';

export const getEmpresasMenus = (navigate, current = 'dashboard') => ([
    {
        label: 'Dashboard CRM',
        id: 'empresas-dashboard',
        selected: current === 'dashboard',
        disabled: false,
        icon: <LayoutDashboard size={18} />,
        onClick: () => navigate('/empresas/dashboard'),
    },
    {
        label: 'Clientes',
        id: 'empresas-gestao',
        selected: current === 'gestao',
        disabled: false,
        icon: <Package size={18} />,
        onClick: () => navigate('/empresas/gestao'),
    },
]);
